export enum OrderEditTimeoutStatus {
  Info = 'info',
  Warning = 'warning',
  Timeout = 'timeout',
}
